import React,{ useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import MUIDataTable from "mui-datatables";
import { 
  language
} from 'config';

export default function CustomerInvoices() {
const settings = useSelector(state => state.settingsdata.settings);
  const auth = useSelector(state => state.auth);
  const date = new Date().toLocaleDateString();

  const columns = [
    {
        name:  "mainAddress",
         label: "Company Details",
         //field: "mainAddress",
         options: {
          sort: false,
          filter: false,
          customBodyRender:() => {
            return auth.info.profile.mainAddress
          }
         }
        },
        {
            name: 'CompanyDetails',
             label: "Provider Details",
             options: {
              sort: false,
              filter: false,
              customBodyRender:() => {
                return settings.CompanyDetails
              }
             }
            },
    {
        name: "tripdate",
         label: "Delivery Time/date",
         field: "tripdate",
        //  {
        //   render: rowData => rowData.tripdate?new Date(rowData.tripdate).toLocaleString(dateStyle):null
        // },
         options: {
          sort: true,
          filter: false,
         }
        },
        {
            name: "customer_paid",
             label: language.Customer_paid,
             field: 'customer_paid',
             options: {
              filter: false,
              sort: true,
             }
            },
            {
              name:  "date",
               label: "Date",
               //field: date,
               options: {
                sort: false,
                filter: false,
                customBodyRender:() => {
                  return date
                }
               }
              },

   ];

  const [data, setData] = useState([]);
   const bookinglistdata = useSelector(state => state.bookinglistdata);
 
   useEffect(()=>{
         if(bookinglistdata.bookings){
             setData(bookinglistdata.bookings);
         }else{
           setData([]);
         }
   },[bookinglistdata.bookings]);

   
   const options = {
     filter:false,
     selectableRows: false,
     searchPlaceholder: "Search Invoices",
     rowsPerPage: 50,
    rowsPerPageOptions: [50, 100, 200],
   };

return (
<MUIDataTable
  title={language.your_invoices}
  data={data}
  columns={columns}
  options={options}
/>
);
}
